;(function() {
  'use strict'

  Controller.$inject = ["$state", "glUtils", "cloudinaryService", "userService", "surveyService"];
  angular.module('core.surveyCard').component('surveyCard', {
    controller: Controller,
    templateUrl: 'survey-card.html',
    bindings: {
      survey: '<',
      layout: '@',
      link: '<',
      onClick: '&?',
      onArchive: '&?',
      onUnarchive: '&?',
      onClone: '&?',
      onView: '&?',
      onMove: '&?',
    },
  })

  /* @ngInject */
  function Controller(
    $state,
    glUtils,
    cloudinaryService,
    userService,
    surveyService
  ) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges
    ctrl.click = click
    ctrl.getBadge = getBadge
    ctrl.getMenuItems = getMenuItems

    function onInit() {
      ctrl.isSSR = userService.isSSR()
    }

    function onChanges() {
      ctrl.isRow = ctrl.layout === 'row'
      ctrl.name = ctrl.survey.reference || ctrl.survey.title
      ctrl.info = getCountsLabel()

      ctrl.href = ctrl.link
        ? $state.href('survey', surveyService.getOpenParams(ctrl.survey))
        : null

      var imageUrl = cloudinaryService.resize(
        ctrl.survey.imageUrl,
        ctrl.isRow ? 160 : 250
      )
      ctrl.imageStyle = imageUrl && {
        backgroundImage: 'url(' + imageUrl + ')',
      }
    }

    function click(event) {
      if (!ctrl.href && ctrl.onClick) {
        ctrl.onClick({ $event: event })
      }
    }

    function getBadge() {
      return surveyService.getBadge(ctrl.survey)
    }

    function getCountsLabel() {
      var survey = ctrl.survey
      var segments = [
        survey.responseCount
          ? glUtils.countLabel(survey.responseCount, 'response')
          : 'no responses',
      ]
      if (survey.questionCount) {
        segments.push(glUtils.countLabel(survey.questionCount, 'question'))
      }
      return segments.join(' · ')
    }

    function getMenuItems() {
      if (ctrl.survey.isArchived) {
        return [
          ctrl.isSSR && ctrl.onView && { text: 'Edit', onClick: ctrl.onView },
          ctrl.onClone && { text: 'Duplicate', onClick: ctrl.onClone },
          ctrl.onMove && { text: 'Move', onClick: ctrl.onMove },
          ctrl.onUnarchive && {
            text: 'Unarchive',
            onClick: ctrl.onUnarchive,
            last: true,
          },
        ]
      }
      return [
        ctrl.onClone && { text: 'Duplicate', onClick: ctrl.onClone },
        ctrl.onMove && { text: 'Move', onClick: ctrl.onMove },
        ctrl.onArchive && {
          text: 'Archive',
          onClick: ctrl.onArchive,
          last: true,
          danger: true,
        },
      ]
    }
  }
})()
